import { Alert, Button } from "antd";

interface ISearchFieldsErrorAlertProps {
    message: string;
    onRetry: () => void;
}

export default function SearchFieldsErrorAlert({ message, onRetry }: ISearchFieldsErrorAlertProps) {
    return (
        <Alert
            type="error"
            showIcon
            title={message}
            action={
                <Button size="small" onClick={onRetry}>
                    Retry
                </Button>
            }
            banner
            style={{ flex: 1 }}
        />
    );
}
